var map = {
	"./": 137,
	"./Clutch": 2650,
	"./Clutch.js": 2650,
	"./NewUi": 2651,
	"./NewUi.js": 2651,
	"./OldUi": 2652,
	"./OldUi.js": 2652,
	"./index": 137,
	"./index.js": 137,
	"./style": 851,
	"./style.js": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4159;